// import AuthService from "services/auth";

// const TWO_WAY_SYNC_FLAG = "faye.two-way-calendar-sync";

/**
 * Can be replaced by a GatedComponent when it's ready for Advisor testing.
 * Right now, I will add it manually to our users.
 */
export const useTwoWaySyncEnabled = (): boolean => {
  return true;
  // const currentUser = AuthService.getCurrentUser();
  // return currentUser?.enabledFeatureFlags?.includes(TWO_WAY_SYNC_FLAG) || false;
};
